<template>
<div>
  <b-container fluid>
    <b-row>
      <b-col :lg="cols">
        <card>
          <TableActionHeader v-on:filterChange="onFilterChange" v-on:newItem="onNewItem"></TableActionHeader> 
          <PowerSocketTable :filter="filter" v-on:selectItem="onSelectItem"></PowerSocketTable>
        </card>
      </b-col>
      <b-col>
        <InfoCard v-if="action == ''"></InfoCard>

        <card v-if="action == 'new'">
          <CardHeader :title="$t('item.new')" />
          <PowerSocketForm v-model="item" action="new"/>
        </card>

        <card v-if="action == 'item'">
          <CardHeader :title="item.name" type="item" />
            <tabs>
              <tab-pane title="tab-1" key="tab-1">
                <b-icon slot="title" icon="arrow-left-right" scale='1.1'></b-icon> 
                <PowerSocketActions v-model="item.deviceId"/>
              </tab-pane>
              <tab-pane  title="tab-2" key="tab-2">
                <b-icon slot="title" icon="card-list" scale='1.1'></b-icon>
                <PowerSocketForm v-model="item" action="edit"/>
              </tab-pane>
              <!--
               <tab-pane  title="tab-3" key="tab-3">
                <b-icon slot="title" icon="diagram3-fill" scale='1.1'></b-icon>
                <PowerSocketForm v-model="item" action="edit"/>
              </tab-pane>
              -->
            </tabs>
        </card>
      </b-col>
<!--  
      <b-col v-if="showForm">
        <card><PowerSocketActions v-model="item.deviceId"></PowerSocketActions></card>
        <card>
          <CardHeader :title="formTitle" v-on:close="onClose"></CardHeader>
          <PowerSocketForm v-model="item" :action="formType"></PowerSocketForm>
        </card>

      </b-col>
-->
     </b-row>
  </b-container>
</div>
</template>

<script>

import PowerSocketTable from '@/components/Devices/Powersockets/PowerSocketTable'
import PowerSocketActions from '@/components/Devices/Powersockets/PowerSocketActions'
import PowerSocketForm from '@/components/Devices/Powersockets/PowerSocketForm'

export default {
 components: {
     PowerSocketTable, 
     PowerSocketActions, 
     PowerSocketForm
  },
  data: function() {
    return {
      cols: 8,
      filter: null,
      item: {},
      action: "",        
    }
  },
  methods: {
    onFilterChange(filter) {
      this.action =""
      this.item = {}
      this.filter = filter
    },
    onNewItem: function() {
      this.item = {};
      this.action = "new"        
    },
    onSelectItem: function(item) {
      if( item !== undefined ) {
        this.item = item;
        this.action = "item"
      }
    }
  }
}
</script>
